export default __webpack_public_path__ + "55e2a01e29a12b298136e7daf0c7af85.svg";